import React, { lazy, Suspense } from "react";
import {
  deepClone,
  showToast,
  formatDateAsPerTimeZoneWithDateAndTime,
  errorHandler,
} from "../../../helper-methods";
import {
  getAgentClosingBidDetail,
  agentAcceptOrRejectBidding,
  agentCounterBidding,
  guestAgentCounterBidding,
  guestAgentAcceptOrRejectBidding,
  checkAgentGuestUser,
  agentAcceptOrRejectBiddingNew,
  agentCounterBiddingNew,
  bidSentToOtherAgents,
  getSecondaryAgents,
} from "../../../http/http-calls";
import { connect } from "react-redux";
import { showLoader, hideLoader } from "../../../redux/actions/loader-data";
import { HeaderEventEmitter } from "../../../helper-methods/HeaderEvents";
import ScreenWidthHOC from "./ScreenWidthHOC";
const BiddingDetails = lazy(() => import("../components/BiddingDetails"));

class NewClosingAgentPublic extends React.Component {
  state = {
    closingDetails: null,
    loading: false,
    isOpenConformationModal: false,
    agentId: "",
    isShareOtherAgentBtnShow: false,
    secondaryAgents: [],
    counterForm: {
      counterAmount: {
        value: "",
        isDirty: false,
        error: null,
      },
      appointmentTime: {
        value: "",
        isDirty: false,
        error: null,
      },
    },
  };

  _extractAgentId = () => {
    return new Promise(async (resolve, reject) => {
      const parts = this.props.match.params.id.split("&");

      let agentId = null;

      for (const part of parts) {
        const [key, value] = part.split("=");
        if (key === "agentid") {
          agentId = value;
        }
      }
      resolve(agentId);
    });
  };

  _redirectToSignup = (e) => {
    if (e) e.preventDefault();
    // const { userData } = this.props;
    const parts = this.props.match.params.id.split("&");

    let agentId = null;

    // console.log("parts >>", parts);

    for (const part of parts) {
      const [key, value] = part.split("=");
      if (key === "agentid") {
        agentId = value;
      }
    }

    if (parts?.includes("guestuser=false")) {
      this.props.history.push(`/login`);
    } else {
      this.props.history.push(`/nna-signup/${agentId}`);
    }

    // this.props.history.push(`/nna-signup/${agentId}`);
  };

  componentDidMount = async () => {
    console.log("1111", this.props);

    try {
      const id = this.props.match.params.id.replace("guestuser=true", "");

      const agentId = await this._extractAgentId();
      console.log("agentId", agentId);

      this.props.showLoader("Fetching Closing Details...");

      const res = await this._getAgentClosingBidDetail(id);
      if (!res?.error) {
        // Check that this agent is primary agent
        if (
          agentId === res?.closing?._websiteAgent &&
          !res?.closing?.isFreeBookingWebsiteClosing
        ) {
          // fetch for secondary agents
          const isSecondaryAgentAvailable = await this._fetchForSecondaryAgents(
            agentId,
            res?.closing?._id
          );
          // console.log("res _fetchForSecondaryAgents", response);
          this.setState({
            isShareOtherAgentBtnShow: isSecondaryAgentAvailable,
          });
        }
      }

      this.props.hideLoader();
    } catch (error) {
      console.log("error _redirectToSignup >>", error);

      errorHandler(error);
      this.props.hideLoader();
      this._redirectToSignup();
    }
  };

  _fetchForSecondaryAgents = (id, closingId) => {
    return new Promise(async (resolve, reject) => {
      const payload = {
        closingId: closingId,
      };
      try {
        const res = await getSecondaryAgents(id, payload);
        if (!res?.error) {
          if (res?.agents?.length > 0) {
            resolve(true);
          } else {
            resolve(false);
          }
          this.setState({
            secondaryAgents: res?.agents || [],
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    });
  };

  _bidSentToOtherAgents = async () => {
    try {
      this.props.showLoader("Sending Bids...");

      const payload = {
        closingId: this.state.closingDetails?.id,
        agentIds: this.state.secondaryAgents,
        agentId: this.state?.agentId,
      };

      const response = await bidSentToOtherAgents(payload);
      if (!response?.error) {
        this.props.hideLoader();
        showToast(
          `Bid sent sunscessfully to ${this.state?.secondaryAgents?.length} agents`,
          "success"
        );
      }
    } catch (error) {
      errorHandler(error);
      this.props.hideLoader();
    }
  };

  _extractUrl = (url) => {
    const queryString = url.split("?")[1];
    const params = new URLSearchParams(queryString);
    const cameViaValue = params.get("cameVia");
    const remainingParams = queryString.replace(`cameVia=${cameViaValue}&`, "");
    return cameViaValue + "&" + remainingParams;
  };

  _checkAgentGuestUser = async () => {
    let agentId = this._extractAgentId(this.props.history.location.search);
    try {
      let response = await checkAgentGuestUser(agentId);
      if (response?.isGuest) {
        console.log("age", agentId);
      } else {
        this.props.history.push("/login");
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  _getAgentClosingBidDetail = (id = null) => {
    const { userData } = this.props;

    if (!id && this.state.closingDetails && this.state.closingDetails.id) {
      id = this.state.closingDetails.id;
    }

    const parts = this.props.match.params.id.split("&");

    let agentId = null;

    for (const part of parts) {
      const [key, value] = part.split("=");
      if (key === "agentid") {
        agentId = value;
      }
    }
    const payload = {
      closingId: parts[0],
      agentId,
    };
    return new Promise((resolve, reject) => {
      getAgentClosingBidDetail(payload)
        .then((res) => {
          this.setState(
            {
              closingDetails: res.closing,
              agentId,
            },
            () => {
              HeaderEventEmitter.dispatch("closing-details", {
                closingDetails: res.closing,
              });
            }
          );
          if (res?.closing?._agent !== undefined) {
            showToast("Job no longer available", "error");
            this.props.history.push(`/${userData.type}/dashboard`);
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  _redirectToDashboard = (e) => {
    if (e) e.preventDefault();
    const { userData } = this.props;
    this.props.history.push(`/${userData?.type}/dashboard`);
  };

  _agentAcceptOrRejectBidding = async (
    status,
    isTermsAndConditionsAccepted = false
  ) => {
    try {
      this.setState({ loading: true });

      const payload = {
        status,
        closingId: this.state.closingDetails?.id,
        agentId: this.state.agentId,
        isTermsAndConditionsAccepted: isTermsAndConditionsAccepted, // need to accept terms and conditions to accept / counter bids
      };

      if (
        this.state.closingDetails?.isAgentWebsiteClosing ||
        this.state.closingDetails?.isFreeBookingWebsiteClosing
      ) {
        await agentAcceptOrRejectBiddingNew(payload);
        this.setState({ loading: false });
        showToast(`Order ${status}`, "success");
        this._redirectToDashboard();
      } else if (this.state.closingDetails?.isGuest) {
        await guestAgentAcceptOrRejectBidding(payload);
        this.setState({ loading: false });
        showToast(`Order ${status}`, "success");
        this._redirectToSignup();
      } else {
        await agentAcceptOrRejectBidding(payload);
        this.setState({ loading: false });
        showToast(`Order ${status}`, "success");
        this._redirectToDashboard();
      }
    } catch (err) {
      this.setState({ loading: false });
      errorHandler(err);
    }
  };

  _onSubmitCounterOffer = async (e, childPayload) => {
    try {
      if (e) e.preventDefault();
      // no need to validate payload here as it is already validated in the child, only check if childPayload is coming or not

      if (childPayload) {
        this.setState({ loading: true });

        const { closingDetails, agentId } = deepClone(this.state);

        let payload = {
          ...childPayload,
          agentId,
        };

        if (
          closingDetails?.isAgentWebsiteClosing ||
          closingDetails?.isFreeBookingWebsiteClosing
        ) {
          await agentCounterBiddingNew(payload);
          this.setState({ loading: false });
          showToast(`Order counter offer has been sent.`, "success");
          this._redirectToDashboard();
        } else if (closingDetails?.isGuest) {
          await guestAgentCounterBidding(payload);
          this.setState({ loading: false });
          showToast(`Order counter offer has been sent.`, "success");
          this._redirectToSignup();
        } else {
          await agentCounterBidding(payload);
          this.setState({ loading: false });
          showToast(`Order counter offer has been sent.`, "success");
          this._redirectToDashboard();
        }
      }
    } catch (error) {
      this.setState({ loading: false });
      errorHandler(error);
    }
  };

  _setCounterFormField = () => {
    const { counterForm, closingDetails } = deepClone(this.state);

    counterForm.counterAmount.value =
      closingDetails?.biddingAmount?.toString() || "";
    // counterForm.appointmentTime.value = closingDetails?.appointmentDate || "";
    counterForm.appointmentTime.value = closingDetails?.appointmentDate
      ? formatDateAsPerTimeZoneWithDateAndTime(
          closingDetails.appointmentDate,
          closingDetails.closingAddress.timeZone
        )
      : "";
    Object.keys(counterForm).forEach((key) => {
      counterForm[key].isDirty = false;
      counterForm[key].error = null;
    });
    this.setState({ counterForm });
  };

  _toggleConformationModal = (value) => {
    this.setState({
      isOpenConformationModal: !this.state.isOpenConformationModal,
    });

    if (value) {
      this._bidSentToOtherAgents();
      console.log("Call _bidSentToOtherAgents >>");
    }
  };

  render() {
    const {
      closingDetails,
      loading,
      counterForm,
      isOpenConformationModal,
      isShareOtherAgentBtnShow,
    } = this.state;

    return (
      <Suspense fallback="Loading...">
        <BiddingDetails
          closingDetails={closingDetails}
          loading={loading}
          counterForm={counterForm}
          isOpenConformationModal={isOpenConformationModal}
          isShareOtherAgentBtnShow={isShareOtherAgentBtnShow}
          agentAcceptOrRejectBidding={this._agentAcceptOrRejectBidding}
          onChangeCounterFormField={this._onChangeCounterFormField}
          onSubmitCounterOffer={this._onSubmitCounterOffer}
          toggleConformationModal={this._toggleConformationModal}
        />
      </Suspense>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userData: state.userData ? state.userData : {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showLoader: (text) => dispatch(showLoader(text)),
    hideLoader: () => dispatch(hideLoader()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScreenWidthHOC(NewClosingAgentPublic));
